import React from 'react';
import { Input } from '../../ui/Input';

export interface FieldHelpTextInputProps {
  value: string;
  onChange: (helpText: string) => void;
}

/** Controlled editor do texto de ajuda (helpText) de um field. */
export const FieldHelpTextInput: React.FC<FieldHelpTextInputProps> = ({ value, onChange }) => (
  <Input
    label="Texto de ajuda"
    value={value}
    onChange={(e) => onChange(e.target.value)}
  />
);
